(function() {(window.nunjucksPrecompiled = window.nunjucksPrecompiled || {})["publications/list_item.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<li";
if(runtime.contextOrFrameLookup(context, frame, "isopen")) {
output += " class=\"open\"";
;
}
output += ">\r\n";
output += "\r\n";
output += "\r\n";
output += "\r\n\r\n";
var t_1;
t_1 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseMonths") > 11?0:11 - runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseMonths"));
frame.set("prX", t_1, true);
if(frame.topLevel) {
context.setVariable("prX", t_1);
}
if(frame.topLevel) {
context.addExport("prX", t_1);
}
output += "\r\n\r\n<div class=\"pub-header\" title=\"";
output += runtime.suppressValue(env.getFilter("transChoice").call(context, ("item.status" + ((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"rmod")?"_modified":""))),runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseMonths"),{"month": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseMonths")}), env.opts.autoescape);
output += "\">\r\n    <span class=\"topic ";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "topic_icons")),runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"topics")),0)), env.opts.autoescape);
output += "\" title=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"topics")),0), env.opts.autoescape);
output += "\"></span>\r\n    <span class=\"title\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"title"), env.opts.autoescape);
output += "</span>\r\n    <span class=\"progress pr";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "prX"), env.opts.autoescape);
output += "\"><span></span></span>\r\n</div>\r\n\r\n<div class=\"pub-body\">\r\n    <div class=\"publication-cover\"><img src=\"covers/";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"cover"), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"title"), env.opts.autoescape);
output += "\"></div>\r\n    <div class=\"publication-adatlap\">\r\n        <div class=\"publication-vazlat\">";
output += runtime.suppressValue(env.getFilter("nl2br").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"desc")), env.opts.autoescape);
output += "</div>\r\n        <hr>\r\n        <div class=\"publication-description\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "item.label_topics"), env.opts.autoescape);
output += " <b>";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"topics"),", "), env.opts.autoescape);
output += "</b></div>\r\n        <div class=\"publication-description\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "item.label_category"), env.opts.autoescape);
output += " <b>";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"categories"),", "), env.opts.autoescape);
output += "</b></div>\r\n        <div class=\"publication-description\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "item.label_language"), env.opts.autoescape);
output += " <b>";
output += runtime.suppressValue(env.getFilter("join").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"langs"),", "), env.opts.autoescape);
output += "</b></div>\r\n\r\n        <div class=\"publication-description\">";
output += runtime.suppressValue(env.getFilter("transChoice").call(context, "item.label_release_date",runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseMonths")), env.opts.autoescape);
output += " <b>";
output += runtime.suppressValue(env.getFilter("date").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseDate"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xReleaseDate")),"formatText")),runtime.contextOrFrameLookup(context, frame, "_lang"))), env.opts.autoescape);
output += "</b></div>\r\n\r\n        ";
var t_2;
t_2 = (runtime.contextOrFrameLookup(context, frame, "_lang") == "hu"?runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"priceHUF"):runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"priceEUR"));
frame.set("item_price", t_2, true);
if(frame.topLevel) {
context.setVariable("item_price", t_2);
}
if(frame.topLevel) {
context.addExport("item_price", t_2);
}
output += "\r\n        ";
if(runtime.contextOrFrameLookup(context, frame, "item_price") != null) {
output += "\r\n            <div class=\"publication-description\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "item.label_price"), env.opts.autoescape);
output += " <b>";
output += runtime.suppressValue(env.getFilter("transChoice").call(context, ("item.price_" + runtime.contextOrFrameLookup(context, frame, "_lang")),runtime.contextOrFrameLookup(context, frame, "item_price"),{"price": (lineno = 26, colno = 149, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "numberFormat"), "numberFormat", context, [runtime.contextOrFrameLookup(context, frame, "item_price")]))}), env.opts.autoescape);
output += "</b></div>\r\n        ";
;
}
output += "\r\n\r\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"pubid")) {
output += "\r\n            <div class=\"publication-data\">\r\n                <p><a href=\"http://www.ksh.hu/apps/shop.kiadvany?";
if(runtime.contextOrFrameLookup(context, frame, "_lang") == "en") {
output += "p_lang=EN&";
;
}
output += "p_kiadvany_id=";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"pubid"), env.opts.autoescape);
output += "\" target=\"_blank\">";
output += runtime.suppressValue(env.getFilter("trans").call(context, "publications.jump_to_publications"), env.opts.autoescape);
output += "</a></p>\r\n            </div>\r\n        ";
;
}
output += "\r\n\r\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"tags")) {
output += "\r\n            <div class=\"publication-description\">\r\n                ";
output += runtime.suppressValue(env.getFilter("trans").call(context, "item.label_tags"), env.opts.autoescape);
output += "\r\n                ";
frame = frame.push();
var t_5 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"tags");
if(t_5) {t_5 = runtime.fromIterator(t_5);
var t_4 = t_5.length;
for(var t_3=0; t_3 < t_5.length; t_3++) {
var t_6 = t_5[t_3];
frame.set("tag", t_6);
frame.set("loop.index", t_3 + 1);
frame.set("loop.index0", t_3);
frame.set("loop.revindex", t_4 - t_3);
frame.set("loop.revindex0", t_4 - t_3 - 1);
frame.set("loop.first", t_3 === 0);
frame.set("loop.last", t_3 === t_4 - 1);
frame.set("loop.length", t_4);
output += "<a href=\"";
output += runtime.suppressValue((lineno = 39, colno = 33, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["publications_tag",{"tag": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"xTagsMap")),t_6)}])), env.opts.autoescape);
output += "\">";
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += "</a>";
output += runtime.suppressValue((!runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "loop")),"last")?", ":""), env.opts.autoescape);
;
}
}
frame = frame.pop();
output += "</div>\r\n        ";
;
}
output += "\r\n    </div>\r\n\r\n    ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"types")) {
output += "\r\n        <div class=\"publication-icon\">\r\n        ";
frame = frame.push();
var t_9 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "item")),"types");
if(t_9) {t_9 = runtime.fromIterator(t_9);
var t_8 = t_9.length;
for(var t_7=0; t_7 < t_9.length; t_7++) {
var t_10 = t_9[t_7];
frame.set("type", t_10);
frame.set("loop.index", t_7 + 1);
frame.set("loop.index0", t_7);
frame.set("loop.revindex", t_8 - t_7);
frame.set("loop.revindex0", t_8 - t_7 - 1);
frame.set("loop.first", t_7 === 0);
frame.set("loop.last", t_7 === t_8 - 1);
frame.set("loop.length", t_8);
output += "\r\n            <img title=\"";
output += runtime.suppressValue(env.getFilter("upper").call(context, t_10), env.opts.autoescape);
output += "\" alt=\"";
output += runtime.suppressValue(env.getFilter("upper").call(context, t_10), env.opts.autoescape);
output += "\" src=\"https://www.ksh.hu/images/kiadvanytar/type_";
output += runtime.suppressValue(t_10, env.opts.autoescape);
output += ".gif\">\r\n        ";
;
}
}
frame = frame.pop();
output += "\r\n        </div>\r\n    ";
;
}
output += "\r\n\r\n    ";
output += "\r\n</div>\r\n</li>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();
